import React, {useState, useEffect} from 'react';
import styled, { keyframes } from 'styled-components'
import history from '../history'
import HowToUse from '../Components/HowToUse';
import NavigBtn from '../Components/NavigBtn';
import SideBar from '../Components/SideBar';
import {Link} from 'react-router-dom'

const WEBHEADER = styled.header`

`
const HEADSEC = styled.section`
display: flex;
justify-content: space-around;
align-items: center;
width: 100%;
overflow-x: hidden;
padding-top: 3rem; 

@media screen and (max-width: 48rem) {
    flex-wrap: wrap;
    
}
@media screen and (min-width: 48rem) {

}
img {

@media screen and (max-width: 48rem) {
    display: none;
}
            @media screen and (min-width: 48rem) {
            width: 50%;
            height: 75%;
            padding: 0 .5rem
            }


}
ul {
    margin: 3rem 3rem 0 3rem;
    width: fit-content;
    li {
         font-size: .8rem;
        list-style-type: none;
        margin-top: 1rem;
        vertical-align: middle;
         span {
            background: #E29A07;
            width: 1rem;
            display: inline-block;
            height: 1rem;
            vertical-align: bottom;
            border-radius: 50%;
        }
    }
    
 }
article {
    align-self: flex-start;
    padding-top: 5rem;
    padding-left: 1rem;

    @media screen and (max-width: 48rem) {
         width: 100%;
    }
    button.btn-app-header {
        z-index: 10;
    position: relative;
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.6));
        display: inline-block;
          background: rgb(38, 20, 49);
   border: 2px solid rgba(38, 20, 49, 0.97);
   box-sizing: border-box;
   border-radius: 5px;
        transition: all .5s ease-in-out;
       font-size: 18px;
       cursor: pointer;
       text-align: center;
         padding: .5rem;
       color: white;
       width: 260px;
       height: 48px;  
         font-size: normal;
         font-weight: 900
        
   }
    p {
        @media screen and (max-width: 48rem) {
             width: fit-content;
        }
        
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 27px;
        padding: 2rem 1rem 2rem 0;
        display: flex;
        align-items: center;
         
        color: #1C1919;
    }
    
    h1 {
        @media screen and (max-width: 48rem) {
            width: fit-content;
             }
 width: 627px;
  
font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 45px;
line-height: 53px;
display: flex;
align-items: center;
text-transform: capitalize;

color: #451E5E;
    }
}
`
const MOBILE = styled.nav`
ul li:first-child {
    font-family: Roboto;
font-style: normal;
font-weight: 900;
font-size: 35px;
line-height: 56px;

@media screen and (max-width: 48rem) {
    margin-left: auto;
}

color: #261431;
}
li {
    list-style-type: none;
}

a {
    text-decoration: none;
}

button.btn-app-header {
    a {
        color: white;
        text-decoration: none;
    }
     display: inline-block;
       background: #FFFFFF;
border: 2px solid rgba(38, 20, 49, 0.97);
box-sizing: border-box;
border-radius: 5px;
     transition: all .5s ease-in-out;
    font-size: 18px;
    cursor: pointer;
    text-align: center;
      padding: .5rem;
    color: rgb(38, 20, 49);
    width: 260px;
    height: 48px;  
      font-size: small;
    &:hover {
        color: white;
        background: rgba(38, 20, 49, 0.97);
    }
}
    position: fixed;
     width: 100vw;
     .container-list {
        display: flex;
        margin: 0;
        width: 100%;
        background-color: white;
        height: 5.5rem;
        align-items: center;
        justify-content: space-between;
        padding: 2rem 5rem;

        ul {
            @media screen and (max-width: 48rem) {
                display: none;
            }
            width: 40rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            a {
                color: rgb(38, 20, 49);
                font-weight: 600;
                font-size: small;

                &:hover {
                    color: #1d458a;
                }
            }
            
        }
`




const ARMSFOOTER = styled.footer`
@media screen and (min-width: 48rem) {
    & section.logo {
        font-family: Roboto;
font-style: normal;
font-weight: 900;
font-size: 35px;
line-height: 56px;
        grid-column-start: 1;
    }
}

@media screen and (max-width: 48rem) {
 & section {
     grid-column-start: 1;
     grid-column-end: 5;
 }
 & section.logo {
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 35px;
    line-height: 56px;
 }

 & article:first-of-type {
    grid-column-start: 2;
    grid-column-end: 5;
 }
 & article:first-of-type + article {
    grid-column-start: 2;
    grid-column-end: 5;
 }
 & article:first-of-type + article + article {
    grid-column-start: 2;
    grid-column-end: 5;
 }

}
overflow-x: hidden;
display: grid;
grid-template-columns: 40% 20% 20% 20%;
grid-gap: 12px;
background: white;
justify-content: space-around;
padding: 3rem .01rem;
align-content: center;
align-items: center;

& section:last-child {

@media screen and (max-width: 48rem) {
    & {
        padding-right: 2rem;
    }
 & p:first-child {
    grid-column-start: 1;
    grid-column-end: 5;
    grid-row-start: 3;
    justify-self: center;
    margin-top: 2rem;
 }

 & p:first-child + ul {
    grid-column-start: 1;
    grid-column-end: 5;
    grid-row-start: 2;
    margin-top: 2rem;
    padding-left: 1.2rem;
  }

 & p:first-child + ul + ul{
    grid-column-start: 1;
    grid-column-end: 5;
    grid-row-start: 1;
  }
    }

margin-top: 5rem;
font-size: 14px;
display: grid;
grid-template-columns: 27% 35% 35%;
grid-column-start: 1;
grid-column-end: 5;

& ul {
    display: flex;
    justify-content: space-around;
    list-style-type: none;
}
}

& article h4 {
    color: #271e2a;
    @media screen and (max-width: 48rem) {
        font-size: larger;
     }
}

& article ul {
    list-style-type: none;
    line-height: 2rem;
    padding-left: 0;
    font-size: 14px;

    & a {
        color: #292727;
        text-decoration: none;
        &:hover {
            text-decoration: underline
        }
    }
}
`
const BTNGO = styled.button`
background: white;
padding: .7rem;
border-radius: .5rem;
outline: none;
color: black;
    border: 2px solid #1d458a;
    font-size: large;
    transition: .5s ease-in-out;
    cursor: pointer;
    display: flex;
    //  margin-left: auto;
     margin-right: .5rem;  
     outline: none;
     &:hover {
        outline: none;
        background: #1d458a;
        border: none;
        color: white;
         transition: .5s ease-in-out;
         transform: translateY(-.3rem)
     }
    
    & + & {
        background: #1d458a;
         border: none;
         color: white;
         transition: .5s ease-in-out;

         &:hover {
            border: 3px solid #1d458a;
             color: black;
             background: white;
             transition: .5s ease-in-out;
             transform: translateY(-.3rem)
         }
         
     }

`
const HEADER = styled.section`
@media screen and (min-width: 48rem) {
    display: none;
}
 
position: relative;

 
 

& h1 {
    text-align: center;
    text-transform: capitalize;
    font-size: 24px;
    font-weight: bold;
    padding-top: 2.5rem;
    color: #451E5E;
    text-shadow: 2px 2px silver;
    line-height: 20px;
  }

  & h5 {
      position: fixed;
      left: 1.2rem;
      top: 1.65rem; 
      height: ${props => props.showMe === "showMe" ? '100vh' : ""};
      width: ${props => props.showMe === "showMe" ? '100vw ' : ""};
     
      @media screen and (min-width: 48rem) {
          display: none;
      }

     }
   
           
& h5 span {
    width: 30px;
    height: 2px;
    background: #0186cb;
    display: block;
    border-radius: 4px;
    margin-bottom: .4rem;
    transition: all 1.1s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    mix-blend-mode: difference;
    font-weight: bolder;

}
 
 
`
const UNDERLINE = styled.span`
text-align: center;
width: 30%;
display: flex;
justify-content: center;
border-bottom: 3px solid rgba(38, 20, 49, 0.97);
padding: 2px;
justify-self: center;
margin: 0 auto;
padding-top: 1.22rem;
`
const ARTICLE = styled.article`
width: 100%;
overflow: hidden;
display: flex;

@media screen and (min-width: 48rem) {
     display: flex;
     justify-content: space-around;
     align-items: center;

     &.strucArt {
            flex-flow: column;
            & section ~ img {
                height: 30rem;
            }
            & section p {
                width: 80%;
                padding: 2rem;
                line-height: 2;
                font-size: 1rem;
            }
          & section h2 {
            font-size: x-large;
            margin: 2rem 2rem 0 2rem;
          }
    }

    &.strucArt + section + & {
         flex-flow: row-reverse;
         
         img {
            padding-top: 15rem;
        }
        & section:first-child {
            align-self: flex-start;
            padding-top: 6rem;

        }
        section h2 {
            font-size: xx-large;
            color: white;
            text-align: center;
        }

        section p {
            color: rgb(224, 215, 215);
            font-size: 1rem;
            padding: 2rem;
            line-height: 2;
            text-align: center;
        }

         section p + section {
            display: flex;
            justify-content: space-around;
            width: 50%;
            margin: 0 auto 

        }
    }
    &.strucArt + section + & + & {
        section h2 {
            text-align: center;
            font-size: xx-large;
        }

        section p {
            padding: 2rem;
            line-height: 2;
        }
    }

     
}

@media screen and (width: 48rem) {
    & img.imgLoan {
     width: 85%;
     height: 40.7rem;
    }

}


@media screen and (max-width: 48rem) {
    flex-flow: column;
    &.strucArt + section + & {
        flex-flow: column;
        section section {
            display: flex;
            justify-content: space-around;
        }
    }
    & img.strucImg {
        width: 100%;
    }
    & img.imgLoan {
        width: 90%;
 }

    & h2 {
        margin-top: 2rem;
        padding: 1rem;

    }
    & p {
        line-height: 2rem;
        padding: .5rem;
        text-align: justify;
        color: #524d4d;
    }
    & p.pLoan {
        line-height: 2rem;
    padding: 1.2rem;
    text-align: justify;
    color: #2d2a2a;
    font-weight: 500;
    
    @media screen and (max-width: 48rem) {
        font-weight: 400;

    }

    }
    & h2.hLoan {
        margin-top: 2rem;
        color: white;
        padding: 1rem

    }
}
`
const SUBS = styled.section`
width: 100%;
overflow: hidden;
display: flex;
// margin-top: .10rem;
@media screen and (width: 48rem) {
    & img {
        height: 20rem;
        width: 80%;
        margin: 0 auto;
        }
}
@media screen and (max-width: 48rem) {
    flex-direction: column-reverse;
    margin-top: 3rem;
    & img {
        height: 20rem;
    }
    & h2 {
        color: white;
    }
}

@media screen and (min-width: 48rem) {

    & img {
         width: 50%;
         }

         & img + article h2 {
             text-align: center;
             font-size: xx-larger;
             color: white;
         }

       article.subsArt {
           flex-flow: column;
           justify-content: center;
             h2 {
                 text-align: center;
                 font-size: xx-larger;

             }
             p {
                 font-size: 1rem;
                 line-height: 2;
                 padding: 2rem;
             }

             section {
                 width: 50%;
                 margin: 0 auto;
             }

         }


}

`
const animStyle = keyframes`
from {
    opacity: 0;
    transform: translateY(3rem);
}
to {
    opacity: 1
    transform: translateY(0rem);
}
`
const AnimText = styled.section`
@media screen and (min-width: 48rem) {
    animation: ${props => props.anim ? animStyle : ''};
    animation-duration: 2s;
}
 
`
const About = () => {

        const[side, setSide] = useState('')
        const[animText, setAnim] = useState(false)
        
        useEffect(() => {
            window.addEventListener('scroll', () => {
    
                let winSPos = window.pageYOffset 
                 if(winSPos > 103 && winSPos < 900) {
                    return setAnim(true)
                } 
                else if(winSPos > 940 && winSPos < 1764) {
                    return setAnim(true)
                }
                else if(winSPos > 1819 && winSPos < 2595) {
                    return setAnim(true)
    
                }
                else if(winSPos > 2808 && winSPos < 3585) {
                    return setAnim(true)
    
                }
                else if(winSPos > 2000) {
                    return setAnim(false)
    
                }
                else {
                    return setAnim(false)
                }
    
    
            })
        })
        

        let spanStyles = {
            spanFirst: {
                transform: "rotate(45deg) translateY(.2rem)",
                transition: "all 1s  cubic-bezier(0.785, 0.135, 0.15, 0.76)",
                background: "red",
            },
            spanSec: {
                transform:"translateY(-0.9rem) translateX(0.2rem) rotate(-75deg)",
                transition: "all 2.5s  cubic-bezier(0.885, 0.135, 0.15, 0.86)",
                background: "blue",
                zIndex: "4",
                opacity: "0",
            },
            spanThird: {
                transform:"translateY(-0.9rem) translateX(-0.2rem) rotate(-45deg)",
                transition: "all 1s  cubic-bezier(0.785, 0.135, 0.15, 0.76)",
                background: "red",
                zIndex: "2",
            }
        }

    return ( 
        <>
  <NavigBtn />  
 <span id='top'></span>
 <WEBHEADER>

<MOBILE>

<ul class="container-list">
        <li id="dashH">
            Iamwealthy  
        </li>
    
         <ul>

           <li> <Link to='/about'>About </Link> </li>  

           <li> <Link to='/help-center'>Help center </Link> </li>  

           <li> <Link to='/faqs'>FAQ's </Link> </li> 

           
           <li> <Link to='/Iamwealthy-login'>
        
          <button class="btn-app-header">
             Login
         </button>
                </Link> 
            </li> 
           

          </ul>
            </ul>

</MOBILE>

    <HEADSEC>
        <article>
            <h1>{'Building a Lifetime of Financial intergrity & freedom'}</h1>
            <p>
            HELLO and WELCOME! Iamwealthy is an international company that helps individuals and co-operations save money, get wealthier than they are, and live up to their dreams. The most easy-to-use finance record and analysis tool </p>

            <button style={{cursor: "pointer"}} class="btn-app-header">
                <Link to="iamwealthy-account" style={{textDecoration: 'none', color: 'white', width: '100%'}}> 
                    Start with ease 
                </Link>            
            </button>

         <ul>
             <li><span></span> Earn Free Loans</li>
             <li><span></span> Save and Study along</li>
             <li><span></span> Stay motivated and inspired</li>
             <li><span></span> Seamlessly track your finance</li>
         </ul>
        </article>

        <img 
        alt={'grow your wealth with Iamwealthy'}
        src={require('../Assets/Images/header-ill.svg')} />

    </HEADSEC>

 </WEBHEADER>

<HEADER showMe={side}>
     <h5 className="meSpan" onClick={() => side === '' ? setSide("showMe") : setSide('')}>
         
        <span style={side === "showMe" ? spanStyles.spanFirst : {display: "block"} }></span>
        <span style={side === "showMe" ? spanStyles.spanSec : {display: "block"} }></span>
        <span style={side === "showMe" ? spanStyles.spanThird : {display: "block"} }></span>

        </h5>  
     
 </HEADER>
 <SideBar showMe = {side} />

    <UNDERLINE/>

<section style={{marginTop:'4rem'}}></section>


<ARTICLE className="strucArt">

    <AnimText anim={animText}>

    <h2>Structure, Analyse and Scale</h2>
    <p className='pLoan'> 
    There is always a difficulty among so many, students, businessmen, and women as well to save accurately. Spending wisely is important and it helps you save more. Iamwealthy helps you keep track and clean records on how you spend your money, be it on a daily, weekly, or monthly basis. All you need do is get our application and follow the instructions. Iamwealthy makes you wealthier.  </p>

    </AnimText>
    <img 
     src={require('../Assets/Images/record.png')} 
    alt="structure, analayse and scale"
    className="strucImg" />
</ARTICLE>

<section style={{height: '4rem'}}></section>


<ARTICLE style={{background:`  url(${require('../Assets/Images/bgFree.png')})`}}>
<AnimText anim={animText}>

    <h2 className='hLoan'>Earn Free Loans (Wealthy Philantropy)</h2>
    <p style={{color: '#e0d7d7'}} className='pLoan'>
        It's time to step up your game! Are you a student and you need financial aid? Are you a business man or woman and you need to boost your ongoing business? Iamwealthy has come to your rescue.
  Iamwealthy is set to give out free loans worth over 5million naira every year to all her commited users
</p>
     <section>

<BTNGO onClick={() => history.push('/helps')} class='learn-more'>Learn More</BTNGO>

<BTNGO> <Link to="iamwealthy-account" style={{textDecoration: 'none', color:'inherit', width: '100%'}}> 
                   Getting started
                </Link></BTNGO>

</section> 
</AnimText>
    <img class='imgLoan' src={require('../Assets/Images/free.png')} alt="structure, analayse and scale" />
</ARTICLE>

<ARTICLE>
<AnimText anim={animText}>
   <h2>Wealthy Library</h2>
  <p className='pLoan'>
      HELLO and WELCOME! To wealthy library where you get fed with information that is sure to help help you a long way. Just a quick reminder, Iamwealthy is an international company that helps individuals save money, get wealthier than they are, and live up to their dreams. Today Iamwealthy has brought to you a market of information about
Banking
Finance
.Motivational
  
     </p>
    </AnimText>

     <img style={{width:'100%'}} src={require('../Assets/Images/libry.png')} alt="structure, analayse and scale" />

</ARTICLE>


<section style={{height: '4rem'}}></section>

    <HowToUse num={2} txt={''} title={'Pay, Structure and Use'} flow={'row-reverse'} />
<SUBS id='subs' style={{padding:'.5rem 0 3rem 0', background:'#261431'}}>

<img 
src={require('../Assets/Images/prev.png')} 
alt='monthy payment system' />

<ARTICLE className="subsArt">
 
      <h2 className="subsHTwo">Subscription</h2>

    <p style={{color: '#e0d7d7'}} className='pLoan'> Using our services requires that you are on our subscription package. This package at the moment is on a monthly basis. This subscriptione is affordable by all students, families, workers and everyone.Subscribe now to Iamwealthy and make wealth
    </p>
   
    <section style={{display:'flex', marginTop: '.2rem', justifyContent:'space-around'}}>

        <BTNGO onClick={() => history.push('/helps')} class='learn-more'>Learn More</BTNGO>

        <BTNGO> <Link to="iamwealthy-account" style={{textDecoration: 'none',color: 'inherit', width: '100%'}}> 
                   Getting started
                </Link> </BTNGO>

    </section>
</ARTICLE>
 </SUBS>

 
<ARMSFOOTER>
 <span id='down'></span>
 
    <section class="logo" style={{justifySelf:'center'}}>Iamwealthy</section>

    <article>

        <h4>Community</h4>
        <ul>
            <li><a href="/">Student life</a> </li>
            <li><a href="/">Business center</a> </li>
            <li><a href="/">Family</a> </li>
            <li><a href="/">Event && Conference</a> </li>
         </ul>

    </article>

    <article>

        <h4 style={{paddingTop: '2rem'}}>Features</h4>
        <ul>
            <li><a href="/">Seamless recording</a> </li>
            <li><a href="/">Offline support</a> </li>
            <li><a href="/">Visualisation</a> </li>
            <li><a href="/"> Study library </a> </li>
            <li><a href="/">Automated analysis </a> </li>
         </ul>
    </article>

    <article>
        <h4>Reach Outs</h4>
        <ul>
            <li><a href="/">Earn free loans</a> </li>
            <li><a href="/">Apply as a merchant</a> </li>
            <li><a href="/">Gallery</a> </li>
            <li><a href="/">Learn more</a> </li>
          </ul>
    </article>
 
<section>
    <p style={{paddingLeft: '2rem'}}>
    © 2020 Iamwealthy International. All right reserved
    </p>

    <ul>
        <li><a href="/">  Terms of service </a></li>
        <li><a href="/"> Privacy Policy  </a></li>
        <li><a href="/"> Security  </a></li>
        <li><a href="/"> Sitemap  </a></li>
    </ul>

    <ul>
        <li><a href='/'><i class="fa fa-twitter" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>

        <li><a href='/'><i class="fa fa-facebook-f" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>

        <li><a href='/'><i class="fas fa-mail-bulk" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>

        <li><a href='/'><i class="fas fa-globe" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>
         
    </ul>
</section>

</ARMSFOOTER>
        </>
     );
 }
 
export default About;